import PropTypes from 'prop-types'
import { isNil } from 'ramda'
import dayjs from 'dayjs'
import isToday from 'dayjs/plugin/isToday'

import ActiveRecord from 'model/activeRecord'
import User from 'model/person/user'

import { getHumanizeTimeFormat12h } from 'utils/helpers/dateHelper'

dayjs.extend(isToday)

class TaskType extends ActiveRecord {
  // named after the GraphQL scheme
  constructor(init) {
    super(init)
    // console.log('> TaskType constructor -', init)
    if (isNil(init)) return undefined
    this._assigned_to = new User(init.assigned_to)
    this._is_completed = init.is_completed
    this._completed_at = init.completed_at
    this._completed_by = init.completed_by
    this._ticket = init.ticket
    this._due_date = init.due_date
    this._type = init.type
    this._body = init.body
    this._position = init.position
  }

  static shape = {
    ...ActiveRecord.shape,
    assigned_to: PropTypes.instanceOf(User),
    is_completed: PropTypes.bool,
    ticket: PropTypes.object,
    due_date: PropTypes.string,
    body: PropTypes.string,
    position: PropTypes.number
  }

  // Getters for class fields
  get assigned_to() {
    return this._assigned_to
  }

  get is_completed() {
    return this._is_completed
  }

  get completed_at() {
    return this._completed_at
  }

  get completed_by() {
    return this._completed_by
  }

  get ticket() {
    return this._ticket
  }

  get due_date() {
    return this._due_date
  }

  get type() {
    return this._type
  }

  get body() {
    return this._body
  }

  get position() {
    return this._position
  }

  // Calculable
  get isTask() {
    // This should only return true for tab mapping purposes
    return this.__typename === 'TaskType'
  }

  get getDueDate() {
    return getHumanizeTimeFormat12h(this.due_date)
  }

  get getCreated() {
    return getHumanizeTimeFormat12h(this.created_at)
  }

  get isToday() {
    return dayjs(this.due_date).isToday()
  }

  get isOverdue() {
    return dayjs(this.due_date).isBefore(dayjs())
  }

  get isUpcoming() {
    return dayjs(this.due_date).isAfter(dayjs())
  }

  get isOverdueAndIncomplete() {
    return this.isOverdue && !this.is_completed
  }
}

export default TaskType
